import AppLayout from "../../../shared/components/AppLayout";
import { siteTexts } from "../../../shared/i18n/siteTexts";
import ChallengeEnginePanel from "../components/ChallengeEnginePanel";

export default function SuperEightPage() {
  return (
    <AppLayout>
      <ChallengeEnginePanel
        title={siteTexts.challenges.modes.super8.title}
        description={siteTexts.challenges.modes.super8.description}
        mode="admin"
        challengeType="super8"
      />
    </AppLayout>
  );
}
